export default __webpack_public_path__ + "static/media/Archdeacon's Legguards of the Abyss.e6b8c2cb.jpg";